import { TypeBody1, TypeH2, TypeH5 } from "../../atoms/fonts/Types";
import { IconAI, IconChip, IconDocument, IconLayers, IconMail } from "../../atoms/icons/Icons";
import { useT } from "../../../i18n/LanguageContext";
import "./SectionTwoContent.css";

// ---- Small live illustrations, one per service ----------------------

function ArtAi() {
	return (
		<div className="art artAi" aria-hidden="true">
			<span className="artAi_node">
				<IconMail />
			</span>
			<span className="artAi_wire">
				<i />
				<i />
				<i />
			</span>
			<span className="artAi_core">
				<IconAI />
			</span>
			<span className="artAi_wire">
				<i />
				<i />
				<i />
			</span>
			<span className="artAi_node">
				<IconLayers />
			</span>
		</div>
	);
}

function ArtWeb() {
	return (
		<div className="art artWeb" aria-hidden="true">
			<div className="artWeb_window">
				<span className="artWeb_bar" />
				<span className="artWeb_hero" />
				<span className="artWeb_a" />
				<span className="artWeb_b" />
				<span className="artWeb_c" />
			</div>
		</div>
	);
}

function ArtApps() {
	return (
		<div className="art artApps" aria-hidden="true">
			<div className="artApps_phone">
				<div className="artApps_feed">
					{Array.from({ length: 10 }).map((_, i) => (
						<span key={i} className={i % 3 === 0 ? "-accent" : ""} />
					))}
				</div>
			</div>
			<div className="artApps_phone -back">
				<div className="artApps_feed -slow">
					{Array.from({ length: 10 }).map((_, i) => (
						<span key={i} className={i % 4 === 1 ? "-accent" : ""} />
					))}
				</div>
			</div>
		</div>
	);
}

function ArtSeo() {
	return (
		<div className="art artSeo" aria-hidden="true">
			<svg viewBox="0 0 220 90" preserveAspectRatio="none">
				<path className="artSeo_area" d="M0 82 L30 76 L60 78 L90 62 L120 58 L150 38 L185 28 L220 10 L220 90 L0 90 Z" />
				<path className="artSeo_line" d="M0 82 L30 76 L60 78 L90 62 L120 58 L150 38 L185 28 L220 10" pathLength="1" />
			</svg>
			<span className="artSeo_pin">#1</span>
		</div>
	);
}

function ArtConsulting() {
	return (
		<div className="art artConsult" aria-hidden="true">
			{[0, 1, 2].map((i) => (
				<span key={i} className="artConsult_row" style={{ "--i": i }}>
					<span className="artConsult_check" />
					<span className="artConsult_line" />
				</span>
			))}
		</div>
	);
}

function ArtSoftware() {
	return (
		<div className="art artSoft" aria-hidden="true">
			<span className="artSoft_box">
				<IconChip />
			</span>
			<span className="artSoft_link" />
			<span className="artSoft_hub">
				<span className="artSoft_grid">
					{Array.from({ length: 6 }).map((_, i) => (
						<i key={i} style={{ "--i": i }} />
					))}
				</span>
			</span>
			<span className="artSoft_link" />
			<span className="artSoft_box">
				<IconDocument />
			</span>
		</div>
	);
}

const ART = {
	ai: ArtAi,
	web: ArtWeb,
	apps: ArtApps,
	seo: ArtSeo,
	consulting: ArtConsulting,
	software: ArtSoftware,
};

// The tile's border lights up around the pointer.
function onMove(e) {
	const r = e.currentTarget.getBoundingClientRect();
	e.currentTarget.style.setProperty("--sx", `${e.clientX - r.left}px`);
	e.currentTarget.style.setProperty("--sy", `${e.clientY - r.top}px`);
}

export function SectionTwoContent() {
	const { t } = useT();
	const items = t("services.items");

	return (
		<div className="servicesContent">
			<header className="servicesContent_header">
				<div className="servicesContent_heading">
					<span className="-eyebrow" data-reveal="rise">
						{t("services.eyebrow")}
					</span>
					<TypeH2 className="servicesContent_title">
						<span data-reveal="tide" style={{ "--d": 1 }}>
							{t("services.title")}
						</span>
					</TypeH2>
				</div>
				<div data-reveal="rise" style={{ "--d": 3 }}>
					<TypeBody1 className="servicesContent_body">{t("services.body")}</TypeBody1>
				</div>
			</header>

			<ul className="servicesGrid">
				{Array.isArray(items) &&
					items.map((item, i) => {
						const Art = ART[item.key];
						return (
							<li
								key={item.key}
								className={`serviceTile serviceTile--${item.key}`}
								data-reveal="rise"
								style={{ "--d": i % 3 }}
								onPointerMove={onMove}
							>
								{Art && <Art />}
								<div className="serviceTile_text">
									<TypeH5 className="serviceTile_title">{item.title}</TypeH5>
									<TypeBody1 className="serviceTile_body">{item.body}</TypeBody1>
									<ul className="serviceTile_points">
										{item.points.map((p) => (
											<li key={p}>{p}</li>
										))}
									</ul>
								</div>
							</li>
						);
					})}
			</ul>
		</div>
	);
}
